import { useNavigate } from "@tanstack/react-router";
import { trpc } from "@/lib/trpc";
import { useCommunity } from "@/contexts/CommunityContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { ChevronLeft, AlertCircle } from "lucide-react";
import { CommunicationForm } from "@/components/forms/CommunicationForm";

export function CreateCommunicationPage() {
  const navigate = useNavigate();
  const { selectedCommunityId } = useCommunity();

  const { data: communities } = trpc.amenity.getUserCommunities.useQuery();

  const selectedCommunity = communities?.find(
    (c) => c.id === selectedCommunityId,
  );
  const isAdmin = selectedCommunity?.role === "COMMUNITY_ADMIN";

  if (!isAdmin) {
    return (
      <div className="container mx-auto max-w-2xl px-4 py-8">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            No tenés permisos para enviar comunicados. Solo los administradores
            del barrio pueden acceder a esta página.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  if (!selectedCommunityId) {
    return (
      <div className="container mx-auto max-w-2xl px-4 py-8">
        <Alert>
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>Seleccioná un barrio primero.</AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="container mx-auto max-w-2xl px-4 py-8">
      <Button
        variant="ghost"
        size="sm"
        className="mb-4"
        onClick={() => navigate({ to: "/" })}
      >
        <ChevronLeft className="mr-2 h-4 w-4" />
        Volver
      </Button>

      <Card>
        <CardHeader>
          <CardTitle>Nuevo comunicado</CardTitle>
        </CardHeader>
        <CardContent>
          <CommunicationForm
            communityId={selectedCommunityId}
            communityName={selectedCommunity?.name ?? ""}
            onSuccess={() => navigate({ to: "/" })}
            onCancel={() => navigate({ to: "/" })}
          />
        </CardContent>
      </Card>
    </div>
  );
}
